'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/collapse/style/css.js
// module id = 257
// module chunks = 0